import { PractitionerIncomeReportType } from './store/practitioner-income.reducers';

const invoicePaidDisplayColumns = [
  'treatmentsInvoicedAmount',
  'labFeesAmount',
  'depositsTakenAmount',
  'discountsAppliedAmount',
  'creditsAppliedAmount',
  'receiptedCommissionAmount',
];

const invoiceIssuedDisplayColumns = [
  'treatmentsInvoicedAmount',
  'labFeesAmount',
  'depositsTakenAmount',
  'discountsAppliedAmount',
  'invoicedCommissionAmount',
];

export function getColumnsForReportType(
  reportType: PractitionerIncomeReportType
): string[] {
  return reportType === PractitionerIncomeReportType.ByInvoiceIssuedDate
    ? invoiceIssuedDisplayColumns
    : invoicePaidDisplayColumns;
}
